module.exports = __webpack_public_path__ + "static/media/check_blue.b721aa30.svg";